import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "cause-cancel",
  templateUrl: "./causecancel.component.html",
  styleUrls: ["./causecancel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CausecancelComponent extends BaseFormComponent<any> {
  Causecancel: any[] = [
    { Id: 6, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CauseCancel.AddressNotVerified") },
    { Id: 7, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CauseCancel.LackOfFood") },
    { Id: 8, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CauseCancel.ByCustomer") },
  ];

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.FillData();
  }

  FillData() {
    this.columns = [];
    const newGroup: any = {};
    // newGroup['test'] = new FormControl('');
    this.formGroup = new UntypedFormGroup(newGroup);
    this.setValue("causeCancelId", "");
  }
  public async save() {
    this.result = this.formGroup.controls["causeCancelId"].value;
    this.close();
  }
}
